import gql from 'graphql-tag';
import client from '$/utils/apolloClient';

const isEmailAlreadyExistQuery = gql`
  query isEmailAlreadyExist($email: String!) {
    isEmailAlreadyExist(email: $email)
  }
`;

const fetchEmailAlreadyExist = async (variables: { email: string }): Promise<boolean> => {
  return await client
    .query({
      query: isEmailAlreadyExistQuery,
      variables: variables,
    })
    .then((data) => {
      return data.data.isEmailAlreadyExist;
    })
    .catch(() => {
      return false;
    });
};

export const isEmailAlreadyExist = (email: string): Promise<boolean> => {
  return fetchEmailAlreadyExist({ email });
};
